export default __webpack_public_path__ + "static/media/cheeseApp.34cbcb79.png";